import { render, staticRenderFns } from "./TableDesktop.vue?vue&type=template&id=536362f6&scoped=true"
import script from "./TableDesktop.vue?vue&type=script&lang=js"
export * from "./TableDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536362f6",
  null
  
)

export default component.exports